import axios from "axios";

export const fetchAutocodeSchedules = async (companyKey) => {
    const response = await axios.get("api/autocodeSchedules/?companyCode=" + companyKey);
    const productionItems = response.data;
    return productionItems;
}

export const fetchAutocodeScheduleById = async (id) => {
    const response = await axios.get("api/autocodeSchedules/" + id);
    const productionItems = response.data;
    return productionItems;
}

export const updateAutocodeSchedule = async (autocodeSchedule) => {
    try {
      const response = await axios.put(`/api/autocodeSchedules/`, autocodeSchedule);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  };

export const createAutocodeSchedule = async (autocodeSchedule) => {
    try {
      const response = await axios.post(`/api/autocodeSchedules/`, autocodeSchedule);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  }

export const deleteAutocodeSchedule = async (id) => {
    try {
      const response = await axios.delete(`/api/autocodeSchedules/${id}`);
      return response;
    } catch (error) {
      throw error.response.data;
    }
  }